import React from "react";
import "../styles/Contact.css";

function ContactPage() {
  return (
    <div className="background-contact">
      <div className="container">
        <div className="title">Get in Touch</div>
        {/*opening text */}
        <div className="content">
          “At Trana Solutions we bring the experience of our clients into the
          present, offering fresh, innovative perspectives to transform your
          financial operations.”
          <br /> <br />
          Let’s work together to create a more efficient, cost-effective future
          for your business. Contact us today to learn how we can help.
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
